// extracted by mini-css-extract-plugin
export var adjustment = "layout-module--adjustment--e328e";
export var container = "layout-module--container--2dd24";
export var firstview = "layout-module--firstview--29131";
export var main = "layout-module--main--bb351";
export var main_contents = "layout-module--main_contents--0f62f";
export var sidebar = "layout-module--sidebar--a4a72";